import { isAfter, isBefore, parse } from 'date-fns';
import get from 'lodash/get';
import some from 'lodash/some';
import last from 'lodash/last';
import sortBy from 'lodash/sortBy';
import { timeUtils } from './timeUtils';
import { MenuStatus } from './constants';

export const menuStatus = (hours, hasAvailableDays, timeZone, isToday) => {
  if (some(hours, hour => timeUtils.isMenuWithinInterval(hour, timeZone))) {
    return MenuStatus.OPEN;
  }
  const latestToHour = last(sortBy(hours, 'to'));
  if (isToday && hours?.length === 1 && isAfter(Date.now(), parse(get(latestToHour, 'to'), 'HH:mm', new Date()))) {
    return MenuStatus.CLOSED;
  }
  if (isBefore(Date.now(), parse(get(latestToHour, 'to'), 'HH:mm', new Date())) || hasAvailableDays) {
    return MenuStatus.PREORDER;
  }
  return MenuStatus.CLOSED;
};
